import { render, staticRenderFns } from "./SupplierOnboardingAgentsPage.vue?vue&type=template&id=437fc385&"
import script from "./SupplierOnboardingAgentsPage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingAgentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports